export default __webpack_public_path__ + "static/storydanny-8fed5abb592dd18850fee4558715639d.jpg";